import { useCordova } from "./use-cordova"

export function useOgustineBridge (): typeof window.ogustineBridge {
  useCordova() // listen deviceredy event
  return window.ogustineBridge
}